// extracted by mini-css-extract-plugin
export default {"shell":"LayoutAuth_shell__zG+LG","main":"LayoutAuth_main__MOx+z","page":"LayoutAuth_page__3t63x","copyright":"LayoutAuth_copyright__0guaS","header":"LayoutAuth_header__OhM54"};